module.exports = __webpack_public_path__ + "static/media/12UNCTAD1.c588b573.jpg";